import Component from "@ember/component"
import { action, set } from "@ember/object"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import findDocument from "cc-frontend/helpers/find-document"

export default class AdminSession extends Component {
  @service("ember-store") store

  @service rpc

  @service query

  @belongsTo("model", "user")
  user

  selectedActionId = null

  @findDocument("selectedActionId", "action") selectedAction

  @action
  selectAction(id) {
    set(this, "selectedActionId", id)
  }
}
